import { createAction, props, union } from '@ngrx/store';

import { DataState } from '../../interfaces';

export const setResults = createAction('[Timetable] setData', props<DataState>());

export const clearResults = createAction('[Timetable] clearResults');

const all = union({
  setResults,
});

export type StateActionsUnion = typeof all;
